import type { RouteLocationNormalized } from '#vue-router'

export const useLoadWapersCornerCommunitySubCategory = () => {
  const communitiesStore = useCommunitiesStore()
  const waperCornersStore = useWaperCornersStore()

  return async (route: RouteLocationNormalized) => {
    try {
      await Promise.all([
        // Fetch data about the community
        communitiesStore.fetchCommunity({
          slug: route.params.communityName as string,
        }),
        // Fetch post categories from the community
        waperCornersStore.fetchWaperCornersCommunitySubcategories(
          route.params.communityName as string,
        ),
        // Fetch posts `waperCorners` from the community subcategory
        waperCornersStore.fetchCommunitySubcategoriesWaperCorners({
          page: getPageQuery(route),
          community: route.params.communityName as string,
          subCategory: route.params.subCategoryName as string,
        }),
      ])
    } catch (error) {
      console.error('from page', error)
    }

    throwIfNotFound(communitiesStore.community)

    // an unknown sub-category answered 200 with its slug in the canonical, which Nuxt 3.21 encodes once more
    // (encodeEventPath: % -> %25): crawlers walked %25 -> %2525 -> ... for ever (AhrefsBot, scanner payloads,
    // ~4 500 requests a day per front, 10/2026). An empty list is a failed fetch: the page is kept
    const subCategories =
      waperCornersStore.communityWaperCornersSubcategoriesList
    if (
      subCategories.length &&
      !subCategories.some((s) => s.slug === route.params.subCategoryName)
    ) {
      throwIfNotFound(null)
    }
  }
}
